import React from 'react';

export default function Button({ children, variant = 'primary', size = 'md', icon, onClick, disabled, style, type = 'button' }) {
  const base = {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    borderRadius: 8, fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.15s ease', border: '1px solid transparent',
    opacity: disabled ? 0.6 : 1, fontFamily: 'inherit',
  };
  const sizes = {
    sm: { padding: '5px 12px', fontSize: 12 },
    md: { padding: '8px 16px', fontSize: 13 },
    lg: { padding: '11px 22px', fontSize: 14 },
  };
  const variants = {
    primary: { background: '#4A6CF7', color: '#fff', borderColor: '#4A6CF7' },
    secondary: { background: '#F3F4F6', color: '#374151', borderColor: '#E5E7EB' },
    danger: { background: '#FF3B30', color: '#fff', borderColor: '#FF3B30' },
    ghost: { background: 'transparent', color: '#4A6CF7', borderColor: '#4A6CF7' },
    outline: { background: 'transparent', color: '#6B7280', borderColor: '#E5E7EB' },
    success: { background: '#34C759', color: '#fff', borderColor: '#34C759' },
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled}
      style={{ ...base, ...sizes[size], ...variants[variant], ...style }}>
      {icon && <span style={{ display: 'flex', alignItems: 'center' }}>{icon}</span>}
      {children}
    </button>
  );
}
